module.exports = __webpack_public_path__ + "img/logo3.b6ac51c1.png";